import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { serviceUrl } from "@/data/site";

export const ServiceCard = ({ service }) => {
  return (
    <article
      className="group bg-white rounded-lg overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_12px_36px_rgba(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-1 flex flex-col"
      data-testid={`service-card-${service.slug}`}
    >
      <div className="relative h-48 overflow-hidden">
        <span className="absolute top-3 left-3 z-10 bg-brand-red text-white text-[11px] font-bold uppercase tracking-wide px-3 py-1 rounded">
          {service.label}
        </span>
        <img
          src={service.image}
          alt={service.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display font-bold text-lg text-brand-black mb-2">{service.name}</h3>
        <p className="text-sm text-gray-600 leading-relaxed mb-5 flex-1">{service.short}</p>
        <Link to={serviceUrl(service.slug)} className="btn-dark text-sm self-start" data-testid={`ver-servico-${service.slug}`}>
          Ver Serviço <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
};
